"use client";

import { Table } from "@tanstack/react-table";
import { X } from "lucide-react";

import { Button } from "../ui/button.tsx";
import { Input } from "../ui/input.tsx";
// import { DataTableViewOptions } from "@/app/examples/tasks/components/data-table-view-options";

// import { priorities, statuses } from "../data/data";
// import { DataTableFacetedFilter } from "./data-table-faceted-filter";
import React from "react";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered =
    table.getPreFilteredRowModel().rows.length >
    table.getFilteredRowModel().rows.length;

  const [searchValue, setSearchValue] = React.useState<string>("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (searchValue == "") {
        table.getColumn("mail")?.setFilterValue(" ");
      } else {
        table.getColumn("mail")?.setFilterValue(searchValue);
      }
    }
  };

  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <div className="tw-flex tw-flex-1 tw-items-center tw-space-x-2 ">
        <div className="tw-mb-3">
          <Input
            placeholder="Suche E-Mail..."
            value={searchValue}
            onChange={(evt) => {
              setSearchValue(evt.target.value);
            }}
            onKeyDown={handleKeyDown}
            className="tw-h-8 tw-w-[150px] lg:tw-w-[250px] tw-bg-white"
          />
        </div>
        <Button
          className="tw-mb-3 tw-h-8 "
          variant="outline"
          size="sm"
          onClick={() => table.getColumn("mail")?.setFilterValue(searchValue)}
        >
          Suchen
        </Button>
        {/* {table.getColumn("status") && (
          <DataTableFacetedFilter
            column={table.getColumn("status")}
            title="Status"
            options={statuses}
          />
        )}
        {table.getColumn("priority") && (
          <DataTableFacetedFilter
            column={table.getColumn("priority")}
            title="Priority"
            options={priorities}
          />
        )} */}
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="tw-h-8 tw-px-2 lg:tw-px-3"
          >
            Reset
            <X className="tw-ml-2 tw-h-4 tw-w-4" />
          </Button>
        )}
      </div>
      {/* <DataTableViewOptions table={table} /> */}
    </div>
  );
}
